export default __webpack_public_path__ + "static/media/neck-pink.89e7dd8b.png";